<template>
  <main-container>
    <main-header />

    <indicador-navegacao />

    <form-container>
      <form-input-grupo tituloGrupo="Dados Da Empresa">
        <div class="d-flex">
          <form-input-individual>
            <label class="form-pergunta-titulo" for="razaoSocial">Razão Social *</label>
            <input maxlength="150" class="form-pergunta-input-text" type="text" id="razaoSocial" v-model="razaoSocial" />
          </form-input-individual>

          <form-input-individual>
            <label class="form-pergunta-titulo" for="nomeFantasia">Nome Fantasia *</label>
            <input maxlength="50" class="form-pergunta-input-text" type="text" id="nomeFantasia" v-model="nomeFantasia" />
          </form-input-individual>
        </div>

        <form-input-individual>
          <label class="form-pergunta-titulo" for="inscricaoEstadual">Inscrição Estadual</label>
          <input maxlength="20" class="form-pergunta-input-text" type="text" id="inscricaoEstadual" v-model="inscricaoEstadual" />
        </form-input-individual>

        <form-input-individual>
          <label class="form-pergunta-titulo">Logomarca</label>
          <upload-logo @upload-logo="uploadLogo" />
        </form-input-individual>
      </form-input-grupo>

      <form-input-grupo tituloGrupo="Endereço">
        <div class="d-flex">
          <form-input-individual style="width: 60%">
            <label class="form-pergunta-titulo" for="enderecoCep">CEP *</label>
            <input class="form-pergunta-input-text" type="text" id="enderecoCep" v-model="endereco.Cep" maxlength="10" @blur="buscaEnderecoPorCep" />
          </form-input-individual>

          <form-input-individual>
            <label class="form-pergunta-titulo" for="enderecoRua">Rua *</label>
            <input class="form-pergunta-input-text" type="text" id="enderecoRua" v-model="endereco.Rua" />
          </form-input-individual>
        </div>

        <div class="d-flex">
          <form-input-individual style="width: 60%">
            <label class="form-pergunta-titulo" for="enderecoNumero">Número</label>
            <input maxlength="10" class="form-pergunta-input-text" type="text" id="enderecoNumero" v-model="endereco.Numero" />
          </form-input-individual>
          <form-input-individual>
            <label class="form-pergunta-titulo" for="enderecoComplemento">Complemento</label>
            <input maxlength="60" class="form-pergunta-input-text" type="text" id="enderecoComplemento" v-model="endereco.Complemento" />
          </form-input-individual>
        </div>

        <div class="d-flex">
          <form-input-individual>
            <label class="form-pergunta-titulo" for="enderecoBairro">Bairro *</label>
            <input maxlength="50" class="form-pergunta-input-text" type="text" id="enderecoBairro" v-model="endereco.Bairro" />
          </form-input-individual>
          <form-input-individual style="width: 60%">
            <label class="form-pergunta-titulo" for="enderecoEstado">Estado (UF) *</label>
            <select class="form-pergunta-input-text" v-model="endereco.Estado" id="enderecoEstado">
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceará</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espírito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Pará</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
              <option value="EX">Estrangeiro</option>
            </select>
          </form-input-individual>
          <form-input-individual>
            <label class="form-pergunta-titulo" for="enderecoCidade">Cidade *</label>
            <input maxlength="50" class="form-pergunta-input-text" type="text" id="enderecoCidade" v-model="endereco.Cidade" />
          </form-input-individual>
        </div>
      </form-input-grupo>

      <form-input-grupo tituloGrupo="Contato">
        <div class="d-flex">
          <form-input-individual>
            <label class="form-pergunta-titulo" for="email">E-mail Principal *</label>
            <input class="form-pergunta-input-text" type="email" id="email" v-model="email" />
          </form-input-individual>

          <form-input-individual>
            <label class="form-pergunta-titulo" for="whatsapp">Whatsapp</label>
            <input class="form-pergunta-input-text" type="tel" id="whatsapp" v-model="whatsapp" maxlength="15" />
          </form-input-individual>
        </div>
      </form-input-grupo>

      <form-input-grupo tituloGrupo="Dados Bancários">
        <div class="d-flex" v-for="(dados, index) in dadosBancarios" :key="index" id="dadosBancarios">
          <form-input-individual style="width: 250%">
            <label class="form-pergunta-titulo">Banco</label>
            <vue-select
              class="style-chooser"
              :id="'dadosBancariosBanco' + index"
              :reduce="banco => banco.Id"
              :options="bancosFormatado"
              label="Descricao"
              v-model="dadosBancarios[index].IdBanco"
            >
              <div slot="no-options">Sem opções disponíveis!</div>
            </vue-select>
          </form-input-individual>

          <form-input-individual>
            <label class="form-pergunta-titulo" :for="'dadosBancariosAgencia' + index">Agência</label>
            <input maxlength="10" class="form-pergunta-input-text" type="text" v-model="dadosBancarios[index].Agencia" :id="'dadosBancariosAgencia' + index" />
          </form-input-individual>

          <form-input-individual style="padding-right: 2px">
            <label class="form-pergunta-titulo" :for="'dadosBancariosContaCorrente' + index">Conta Corrente</label>
            <input
              class="form-pergunta-input-text mr-2"
              type="text"
              v-model="dadosBancarios[index].ContaCorrente"
              :id="'dadosBancariosContaCorrente' + index"
              maxlength="20"
            />
          </form-input-individual>
          <span style="margin-top: 52px; font-size: 20px">-</span>
          <form-input-individual style="width: 30%; padding-left: 2px">
            <label class="form-pergunta-titulo" :for="'digitoVerificadorConta' + index">DV</label>
            <input
              maxlength="1"
              class="form-pergunta-input-text"
              type="text"
              v-model="dadosBancarios[index].DigitoVerificadorConta"
              :id="'digitoVerificadorConta' + index"
            />
          </form-input-individual>

          <button class="form-pergunta-adiciona-registro" v-if="index === 0" @click="addFormDadosBancarios">+</button>
          <button class="form-pergunta-deleta-registro" v-if="index !== 0" @click="removeFormDadosBancarios(index)">-</button>
        </div>
      </form-input-grupo>

      <form-input-grupo tituloGrupo="Fiscal">
        <div class="d-flex">
          <form-input-individual>
            <label class="form-pergunta-titulo">Regime Fiscal *</label>
            <div id="regimeFiscal">
              <div class="custom-radio custom-control" v-for="_regimeFiscal in regimesFiscais" :key="_regimeFiscal.Id">
                <input class="custom-control-input" type="radio" :id="_regimeFiscal.Descricao" :value="_regimeFiscal" v-model="regimeFiscal" />
                <label class="custom-control-label" :for="_regimeFiscal.Descricao">{{ _regimeFiscal.Descricao }}</label>
              </div>
            </div>
          </form-input-individual>

          <form-input-individual v-if="regimeFiscal.Id === regimeTributarioSimplesId">
            <label class="form-pergunta-titulo">Regime Tributário *</label>
            <div id="regimeTributario">
              <div class="custom-radio custom-control" v-for="_regimeTributario in regimesTributarios" :key="_regimeTributario.Id">
                <input class="custom-control-input" type="radio" :id="_regimeTributario.Descricao" :value="_regimeTributario" v-model="regimeTributario" />
                <label class="custom-control-label" :for="_regimeTributario.Descricao">{{ _regimeTributario.Descricao }}</label>
              </div>
            </div>
          </form-input-individual>
        </div>
      </form-input-grupo>

      <form-input-grupo tituloGrupo="Classificação Empresa">
        <form-input-individual>
          <label class="form-pergunta-titulo">Tipo de atividade</label>
          <div class="custom-checkbox ml-4" id="tipoclassificacaoContribuinte">
            <input class="custom-control-input" type="checkbox" id="executa-atividade-industrial" v-model="tipoclassificacaoContribuinte" />
            <label for="executa-atividade-industrial" class="custom-control-label"
              >Marque o checkbox se sua empresa execute alguma atividade industrial ou equivalente.</label
            >
          </div>
        </form-input-individual>

        <form-input-individual v-if="tipoclassificacaoContribuinte">
          <label class="form-pergunta-titulo">Classificação Do Estabelecimento *</label>
          <div id="classificacaoContribuinte">
            <div class="custom-radio custom-control" v-for="_classificacaoContribuinte in classificacoesContribuintes" :key="_classificacaoContribuinte.Id">
              <input
                :value="_classificacaoContribuinte"
                class="custom-control-input"
                type="radio"
                :id="_classificacaoContribuinte.Descricao"
                v-model="classificacaoContribuinte"
              />
              <label class="custom-control-label" :for="_classificacaoContribuinte.Descricao">{{ _classificacaoContribuinte.Descricao }}</label>
            </div>
          </div>
        </form-input-individual>
      </form-input-grupo>

      <form-buttons
        @voltar-form-anterior="voltarFormAnterior()"
        @avancar-proximo-form="avancarProximoForm(objetoValidacao, montaObjetoCommit, 'commit', 'setDataEmpresaPT3', '/implantacao')"
      />
    </form-container>
  </main-container>
</template>

<script>
import swal from '../../utils/alerts';

export default {
  data() {
    return {
      razaoSocial: '',
      nomeFantasia: '',
      inscricaoEstadual: '',
      endereco: {
        Cep: '',
        Rua: '',
        Numero: '',
        Complemento: '',
        Cidade: '',
        Estado: '',
        Bairro: '',
      },
      email: '',
      whatsapp: '',
      logomarca: '',
      dadosBancarios: [
        {
          IdBanco: '',
          Agencia: '',
          ContaCorrente: '',
          DigitoVerificadorConta: '',
        },
      ],
      regimeFiscal: {
        Id: '',
        Descricao: '',
      },
      regimeTributario: {
        Id: '',
        Descricao: '',
      },
      classificacaoContribuinte: {
        Id: '',
        Descricao: '',
        TipoAtividade: '',
      },
      regimeTributarioSimplesId: 1,
      tipoclassificacaoContribuinte: '',
      bancos: [],
      classificacoesContribuintes: [],
      regimesFiscais: [],
      regimesTributarios: [],
      habilitaRequisicaoCep: false,
    };
  },
  computed: {
    objetoValidacao() {
      const data = [];
      data.push(this.montaObjetoValidacao(['campoObrigatorio', 'maxCaracteres'], this.razaoSocial, 'razaoSocial', 50));
      data.push(this.montaObjetoValidacao(['campoObrigatorio', 'maxCaracteres'], this.nomeFantasia, 'nomeFantasia', 50));
      data.push(this.montaObjetoValidacao(['maxCaracteres'], this.inscricaoEstadual, 'inscricaoEstadual', 20));
      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.$options.filters.formataMascara(this.endereco.Cep), 'enderecoCep'));
      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.endereco.Rua, 'enderecoRua'));
      data.push(this.montaObjetoValidacao(['maxCaracteres'], this.endereco.Numero, 'enderecoNumero', 10));
      data.push(this.montaObjetoValidacao(['maxCaracteres'], this.endereco.Complemento, 'enderecoComplemento', 60));
      data.push(this.montaObjetoValidacao(['campoObrigatorio', 'maxCaracteres'], this.endereco.Cidade, 'enderecoCidade', 50));
      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.endereco.Estado, 'enderecoEstado'));
      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.endereco.Bairro, 'enderecoBairro'));
      data.push(this.montaObjetoValidacao(['campoObrigatorio', 'validaEmail'], this.email, 'email'));
      data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.regimeFiscal, 'regimeFiscal'));

      this.dadosBancarios.forEach((value, index) => {
        data.push(this.montaObjetoValidacao(['apenasNumeros'], this.dadosBancarios[index].IdBanco, `dadosBancariosBanco${index}`));
        data.push(this.montaObjetoValidacao(['apenasNumeros'], this.dadosBancarios[index].Agencia, `dadosBancariosAgencia${index}`));
        data.push(this.montaObjetoValidacao(['apenasNumeros'], this.dadosBancarios[index].ContaCorrente, `dadosBancariosContaCorrente${index}`));
        data.push(this.montaObjetoValidacao(['apenasNumeros'], this.dadosBancarios[index].DigitoVerificadorConta, `dadosBancariosContaCorrente${index}`));
      });

      if (this.regimeFiscal.Id === this.regimeTributarioSimplesId)
        data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.regimeTributario, 'regimeTributario'));
      if (this.tipoclassificacaoContribuinte)
        data.push(this.montaObjetoValidacao(['campoObrigatorio'], this.classificacaoContribuinte, 'classificacaoContribuinte'));

      return data;
    },

    montaObjetoCommit() {
      const dadosBancarios = this.dadosBancarios.filter(d => {
        return d.IdBanco != '' && d.IdBanco != 0 && d.Agencia != '' && d.ContaCorrente != '' && d.DigitoVerificadorConta != '';
      });

      return {
        razaoSocial: this.razaoSocial,
        nomeFantasia: this.nomeFantasia,
        inscricaoEstadual: this.inscricaoEstadual,
        endereco: this.endereco,
        email: this.email,
        whatsapp: this.whatsapp,
        logomarca: this.logomarca,
        regimeFiscal: this.regimeFiscal,
        regimeTributario: this.regimeTributario,
        classificacaoContribuinte: this.classificacaoContribuinte,
        tipoclassificacaoContribuinte: this.tipoclassificacaoContribuinte,
        dadosBancarios,
      };
    },

    cep() {
      return this.endereco.Cep;
    },

    numero() {
      return this.endereco.Numero;
    },

    bancosFormatado() {
      const bancosLabel = JSON.parse(JSON.stringify(this.bancos));
      bancosLabel.forEach(banco => {
        banco.Descricao = `${banco.Id} - ${banco.Descricao}`;
      });
      return bancosLabel;
    },
  },
  methods: {
    addFormDadosBancarios() {
      this.dadosBancarios.push({ IdBanco: '', Agencia: '', ContaCorrente: '', DigitoVerificadorConta: '' });
    },

    removeFormDadosBancarios(index) {
      this.dadosBancarios.splice(index, 1);
    },

    uploadLogo(logo) {
      this.logomarca = logo;
    },

    setaRegimeFiscalInicial(idRegimeFiscal) {
      const idSimples = 1;
      const idLucroPresumido = 2;
      const idLucroReal = 3;

      if (idRegimeFiscal === idSimples) return { Id: idRegimeFiscal, Descricao: 'Simples' };
      if (idRegimeFiscal === idLucroPresumido) return { Id: idRegimeFiscal, Descricao: 'Lucro Presumido' };
      if (idRegimeFiscal === idLucroReal) return { Id: idRegimeFiscal, Descricao: 'Lucro Real' };
    },

    inicializaDados() {
      this.razaoSocial = this.$store.state.dadosEmpresa.razaoSocial;
      this.nomeFantasia = this.$store.state.dadosEmpresa.nomeFantasia;
      this.inscricaoEstadual = this.$store.state.dadosEmpresa.inscricaoEstadual;
      this.endereco.Cep = this.$store.state.dadosEmpresa.endereco.Cep;
      this.endereco.Rua = this.$store.state.dadosEmpresa.endereco.Rua;
      this.endereco.Numero = this.$store.state.dadosEmpresa.endereco.Numero;
      this.endereco.Complemento = this.$store.state.dadosEmpresa.endereco.Complemento;
      this.endereco.Cidade = this.$store.state.dadosEmpresa.endereco.Cidade;
      this.endereco.Estado = this.$store.state.dadosEmpresa.endereco.Estado;
      this.endereco.Bairro = this.$store.state.dadosEmpresa.endereco.Bairro;
      this.email = this.$store.state.dadosEmpresa.email;
      this.whatsapp = this.$store.state.dadosEmpresa.whatsapp;
      this.logomarca = this.$store.state.dadosEmpresa.logomarca;
      this.dadosBancarios = this.$store.state.dadosEmpresa.dadosBancarios;
      this.regimeFiscal = this.setaRegimeFiscalInicial(this.$store.state.dadosEmpresa.regimeFiscal.Id);
      this.regimeTributario = this.$store.state.dadosEmpresa.regimeTributario;
      this.classificacaoContribuinte = this.$store.state.dadosEmpresa.classificacaoContribuinte;
      this.tipoclassificacaoContribuinte = this.$store.state.dadosNavegacao.tipoclassificacaoContribuinte;
      this.bancos = this.$store.state.dadosFormulario.bancos;
      this.classificacoesContribuintes = this.$store.state.dadosFormulario.classificacoesContribuintes;
      this.regimesFiscais = this.$store.state.dadosFormulario.regimesFiscais;
      this.regimesTributarios = this.$store.state.dadosFormulario.regimesTributarios;

      if (this.dadosBancarios.length == 0) this.addFormDadosBancarios();
    },

    removeLetrasDadosBancarios() {
      this.$watch(
        'dadosBancarios',
        value => {
          value.forEach((dadoBancario, index) => {
            this.dadosBancarios[index].Agencia = this.$options.filters.removeLetras(dadoBancario.Agencia);
            this.dadosBancarios[index].ContaCorrente = this.$options.filters.removeLetras(dadoBancario.ContaCorrente);
            this.dadosBancarios[index].DigitoVerificadorConta = this.$options.filters.removeLetras(dadoBancario.DigitoVerificadorConta);
          });
        },
        { deep: true },
      );
    },

    buscaEnderecoPorCep() {
      const payload = { Cep: this.$options.filters.formataMascara(this.endereco.Cep) };

      this.$store.dispatch('integracaoApiBuscaEnderecoPorCep', payload).then(res => {
        if (res.data.erro) return swal.exibirMensagemErro('Não foi encontrado nenhum endereço para o CEP informado.');
        this.endereco.Cep = res.data.cep;
        this.endereco.Rua = res.data.logradouro;
        this.endereco.Cidade = res.data.localidade;
        this.endereco.Estado = res.data.uf;
        this.endereco.Complemento = res.data.complemento;
        this.endereco.Numero = '';
        this.endereco.Bairro = res.data.bairro;
      });
    },
  },
  watch: {
    whatsapp(numero) {
      this.whatsapp = this.$options.filters.formataCelular(numero);
    },

    cep(cep) {
      this.endereco.Cep = this.$options.filters.formataCep(cep);
    },

    inscricaoEstadual(ie) {
      this.inscricaoEstadual = this.$options.filters.removeLetras(ie);
    },

    numero(numero) {
      this.endereco.Numero = this.$options.filters.removeLetras(numero);
    },

    razaoSocial(razaoSocial) {
      this.razaoSocial = this.$options.filters.removeCaracteresEspeciais(razaoSocial);
    },

    nomeFantasia(nomeFantasia) {
      this.nomeFantasia = this.$options.filters.removeCaracteresEspeciais(nomeFantasia);
    },
  },
  created() {
    this.inicializaDados();
  },
  mounted() {
    this.removeLetrasDadosBancarios();
  },
};
</script>

<style></style>
